'use client'

import dynamic from 'next/dynamic'

export const ShopMapBlockLazy = dynamic(() => import('./shop-map-block').then(m => m.ShopMapBlock), {
  ssr: false,
  loading: () => <div style={{height: 600}} />,
})
